// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"580ff299","418":"9b87d4e9","668":"6aa47a2a","739":"46572253"}[chunkId] + ".js";
};